import LangEnum from '../../../../lang/LangEnum';
import { RecoverPasswordOutcome, RecoverPasswordResult } from './recoverPasswordPanel.types';

const SECONDS_PER_MINUTE = 60;

export const normalizeRecoveryEmail = (email: string) => email.trim().toLowerCase();

export const formatCooldown = (seconds: number) => {
  const minutes = Math.floor(seconds / SECONDS_PER_MINUTE);
  const remainingSeconds = seconds % SECONDS_PER_MINUTE;

  return `${minutes}:${String(remainingSeconds).padStart(2, '0')}`;
};

export const getRecoverPasswordOutcome = (
  result: RecoverPasswordResult,
): RecoverPasswordOutcome | null => {
  if (result.ok) {
    return { retryAfterSeconds: result.data?.retryAfterSeconds ?? 0, isRateLimited: false };
  }

  if (result.data?.code === LangEnum.API_EXCEPTION_RECOVER_PASSWORD_RATE_LIMITED) {
    return { retryAfterSeconds: result.data.data?.retryAfterSeconds ?? 0, isRateLimited: true };
  }

  return null;
};
